// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/collapse/style/index.less
// module id = 1776
// module chunks = 1